import { AxiosResponse } from 'axios'
import { http } from '@/core/classes/HTTP.class'

import { CrmCreateDealPayload } from './types/crm'

const BASE_URL = process.env.VUE_APP_GATEWAY_URL

type ApiCreateDealResponse = Promise<AxiosResponse<void>>

export function createDeal(payload: CrmCreateDealPayload): ApiCreateDealResponse {
    return http.post(`${BASE_URL}/crm/api/deals`, payload)
}
export default {
    createDeal,
}
